import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import ImageGeneration from "./ImageGeneration";

export default function HorizontalGallery({
  images,
  loading = false,
  onClick = (image) => console.log(image),
  showError = true,
  size = 200,
  showMenu = true,
  menuItems = [],
}) {

  console.log(menuItems);

  const renderImages = () => {
    if (loading) {
      return (
        <>
          <Skeleton variant="rectangular" width={size} height={size} sx={{ flex: "0 0 auto" }} />
          <Skeleton variant="rectangular" width={size} height={size} sx={{ flex: "0 0 auto" }} />
          <Skeleton variant="rectangular" width={size} height={size} sx={{ flex: "0 0 auto" }} />
          <Skeleton variant="rectangular" width={size} height={size} sx={{ flex: "0 0 auto" }} />
          <Skeleton variant="rectangular" width={size} height={size} sx={{ flex: "0 0 auto" }} />
          <Skeleton variant="rectangular" width={size} height={size} sx={{ flex: "0 0 auto" }} />
          <Skeleton variant="rectangular" width={size} height={size} sx={{ flex: "0 0 auto" }} />
          <Skeleton variant="rectangular" width={size} height={size} sx={{ flex: "0 0 auto" }} />
        </>
      );
    }
    return images
      .filter((imageGeneration) => showError || !imageGeneration.error)
      .map((imageGeneration, index) => {
        return (
          <ImageGeneration
            key={imageGeneration.id}
            imageGeneration={imageGeneration}
            onClick={onClick}
            size={size}
            showMenu={showMenu}
            menuItems={menuItems}
          />
        );
      });
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        overflowX: "auto",
        overflowY: "hidden",
        maxWidth: "100%",
      }}
      // sx={{
      //   display: "flex",
      //   overflowX: "auto", // horizontal scroll
      //   overflowY: "hidden", // prevent vertical scroll
      //   gap: 2,
      //   // padding: 1,
      //   maxWidth: "100%", // constrain width
      //   "&::-webkit-scrollbar": { height: 8 }, // optional scrollbar styling
      // }}
    >
      {renderImages()}
    </Stack>
  );
}
